<template>
<div class="modal-mask-pause background-melody">
    <div class="modal-wrapper-pause">
        <div class="modal-container-pause">
            <div class="modal-header-pause tamanhotitle">
                <slot name="header">
                    {{$t('games.shared.error')}}
                </slot>
            </div>
            <div class="modal-body-pause">
                <div class="label-style-pause tamanho0">
                    <span>{{$t('games.shared.home')}}</span>
                    <span>{{$t('games.shared.closed')}}</span>
                </div>
                <slot name="body">
                    <div class="tamanhoicon" @click="$emit('returnHome')">
                        <img :src="require('@/assets/buttons/newbuttons/melody/home.svg')" />
                    </div>
                    <div class="tamanhoicon" @click="$emit('closeModal')">
                        <img :src="require('@/assets/buttons/newbuttons/general/close.svg')" />
                    </div>

                </slot>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: "ErrorModal",
    emits: ['closeModal', 'returnHome'],
    created() {},
    data() {
        return {};
    },
    props: {},
    methods: {},
};
</script>

<style>
.modal-mask-error-melody {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(78, 146, 105, 0.7);
    display: table;
    transition: opacity 0.3s ease;
}

.modal-wrapper-error-melody {
    display: table-cell;
    vertical-align: middle;
}

.modal-container-error-melody {
    width: 50%;
    margin: 0px auto;
    background-color: #FFBF84;
    padding: 2em;
    border-radius: 25px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    font-family: Omnes, sans-serif;
    animation: movecontainerError 1s ease-in-out;
}
@keyframes movecontainerError {
  0% {margin-top:-100%;}
  100% {margin-top:0;}
}
.modal-header-error-melody {
    display: flex;
    align-self: center;
    flex-wrap: wrap;
    align-items: center;
    align-content: center;
    justify-content: space-around;
}

.modal-header-error-melody h1 {
    color: white;
    text-align: center;
}

.modal-body-error-melody {
    margin-top: 1em;
    display: flex;
    align-self: center;
    flex-wrap: wrap;
    align-items: center;
    align-content: center;
    justify-content: space-around;
}

.modal-default-button {
    float: right;
}
.modal-body-error-melody > div > img {
    width:100%;
}
  .modal-body-error-melody > div{
    width: 3.5rem;
    height: 3.5rem;
  }

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter-from,
.modal-leave-to {
    opacity: 0;
}

.modal-enter-active .modal-container,
.modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}


@media only screen and (max-width: 480px) {
  .modal-body-error-melody h1 {
    font-size: 1.2rem;
  }
  .no-errormodal{
    width:2rem;
  }
  .yes-errormodal{
    width:2rem;
  }
}
@media only screen and (min-width: 480px) and (max-width: 550px) {
  .modal-body-error-melody h1 {
    font-size: 1.4rem;
  }
  .no-errormodal{
    width:2.2rem;
  }
  .yes-errormodal{
    width:2.2rem;
  }
}
@media only screen and (min-width: 550px) and (max-width: 630px){
  .modal-body-error-melody h1 {
    font-size: 1.6rem;
  }
  .no-errormodal{
    width:2.4rem;
  }
  .yes-errormodal{
    width:2.4rem;
  }
}
@media only screen and (min-width: 630px) and (max-width: 718px){
  .modal-body-error-melody h1 {
    font-size: 1.8rem;
  }
  .no-errormodal{
    width:2.6rem;
  }
  .yes-errormodal{
    width:2.6rem;
  }
}
@media only screen and (min-width: 718px) and (max-width: 806px) {
  .modal-body-error-melody h1 {
    font-size: 2rem;
  }
  .no-errormodal{
    width:2.8rem;
  }
  .yes-errormodal{
    width:2.8rem;
  }
}
@media only screen and (min-width: 806px) and (max-width: 1024px) {
  .modal-body-error-melody h1 {
    font-size: 2.2rem;
  }
  .no-errormodal{
    width:3rem;
  }
  .yes-errormodal{
    width:3rem;
  }
}
@media only screen and (min-width: 1024px) and (max-width: 1200px) {
  .modal-body-error-melody h1 {
    font-size: 2.4rem;
  }
  .no-errormodal{
    width:3.2rem;
  }
  .yes-errormodal{
    width:3.2rem;
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1366px) {
  .modal-body-error-melody h1 {
    font-size: 2.6rem;
  }
  .no-errormodal{
    width:3.4rem;
  }
  .yes-errormodal{
    width:3.4rem;
  }
}
@media only screen and (min-width: 1366px) and (max-width: 1540px){
  .modal-body-error-melody h1 {
    font-size: 2.8rem;
  }
  .no-errormodal{
    width:4rem;
  }
  .yes-errormodal{
    width:4rem;
  }
}
@media only screen and (min-width: 1540px) and (max-width: 1680px){
  .modal-body-error-melody h1 {
    font-size: 3rem;
  }
  .no-errormodal{
    width:4.4rem;
  }
  .yes-errormodal{
    width:4.4rem;
  }
}
@media only screen and (min-width: 1680px) and (max-width:2350px){
  .modal-body-error-melody h1 {
    font-size: 3.2rem;
  }
  .no-errormodal{
    width:4.8rem;
  }
  .yes-errormodal{
    width:4.8rem;
  }
}
@media only screen and (min-width: 2350px) {
  .modal-body-error-melody h1 {
    font-size: 3.4rem;
  }
  .no-errormodal{
    width:5.4rem;
  }
  .yes-errormodal{
    width:5.4rem;
  }
}
</style>
